import { SET_CHARGE_AMOUNT } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const setChargeAmount = amount => ({
  type: SET_CHARGE_AMOUNT,
  payload: amount,
});
